<template>
	<div class="container">
		<!--内容-->
		<div class="main_box">
			<!--banner-->
			<div class="banner_box">
				<div class="left">
					<div
						class="tit"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-bottom: 18px;"
					>
						Aiiso Truth Code
					</div>
					<div
						v-if="false"
						class="txt"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="400"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-bottom: 8px;"
					>库尔·企业文化</div>
					<div
						v-if="false"
						class="txt"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="700"
						data-aos-offset="0"
						data-aos-once="true"
					>
						@21&nbsp;意指
					</div>
					<div
						v-if="false"
						class="txt"
						data-aos="fade-right"
						data-aos-duration="400"
						data-aos-delay="1000"
						data-aos-offset="0"
						data-aos-once="true"
					>甭管三七二十一&nbsp;撸起袖子加油干</div>
				</div>
				<div class="right animate__animated animate__fadeIn">
					<img src="../../../assets/img_public/about/qywh/banner_img.png" />
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="main_box_1">
				<!--关联网站-->
				<div class="link_box" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<!-- <div class="tit">关联网站</div> -->
					<div v-for="(value, index) in linkData" class="link_main">
						<div v-for="(value2, index2) in value.data" :class="value2.class">
							<a :href="value2.href">
								<img :src="value2.imgUrl" />
							</a>
						</div>
					</div>
				</div>
				<!--关联网站-->
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_1.png" />
					</div>
					<div class="tit">Natural Science Principles</div>
					<div class="txt">Proven & Currently Unverifiable Existences</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_2.png" />
					</div>
					<div class="tit">The Law of Growth</div>
					<div class="txt">1.&nbsp;Enhance Learning to Improve Abilities</div>
					<div class="txt">2.&nbsp;Continuously Implement Execution</div>
					<div class="txt">3.&nbsp;Regularly Identify & Correct Shortcomings</div>
					<div class="txt">4.&nbsp;Be Dedicated & Responsible at Work</div>
					<div class="txt">5.&nbsp;Build a Community of Shared Interests</div>
				</div>
				<!--区域2-->
			</div>
			<!--块1-->
			<!--块2-->
			<div class="main_box_2">
				<!--区域1-->
				<div class="block_1">
					<img src="../../../assets/img_public/about/qywh/spirit_h5.webp" />
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_3.webp" />
					</div>
					<div class="tit">Work Requirements@21</div>
					<div class="tit_spec">Always Think While You Work</div>
					<div class="txt">What to do, by Whom;</div>
					<div class="txt">When, Where, & How to Perform Tasks;</div>
					<div class="txt">What Documents, Equipment & Materials Shall beUsed;</div>
					<div class="txt">How to Monitor & Measure these Activities;</div>
					<div class="txt">Documentation Required by Stakeholders. </div>
				</div>
				<!--区域2-->
				<!--区域1-->
				<div class="block_3" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_4.png" />
					</div>
					<div class="tit">Two Learning & One Action</div>
					<div class="txt">Learn Cultural Regulations</div>
					<div class="txt">Learn Professional Skills</div>
					<div class="txt">Be A Qualified Colleague</div>
				</div>
				<!--区域1-->
			</div>
			<!--块2-->
			<!--块3-->
			<div class="main_box_3">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="main_box">
						<div class="main_box_el">
							<div class="tit">Working Principles</div>
							<div class="diver"></div>
							<div class="txt">Follow the Rules,</div>
							<div class="txt">Proceed Step by Step</div>
							<div class="txt">Focus on Details,</div>
							<div class="txt">Then Fuel Innovation</div>
						</div>
						<div class="main_box_el line_spec">
							<div class="tit">Decision Making Procedures</div>
							<div class="diver"></div>
							<div class="txt">Democratic Decision Making (Roughly Three Talk)</div>
							<div class="txt" style="padding-top: 11px;">Authoritative Management (Chief System)</div>
							<div class="txt" style="padding-top: 11px;">Major Decisions Confirmation (President's Office)</div>
						</div>
					</div>
					<div class="main_box">
						<div class="main_box_el">
							<div class="tit">Production Guidelines</div>
							<div class="diver"></div>
							<div class="txt">Follow Operating Standards</div>
							<div class="txt">Meet Quality Standards</div>
							<div class="txt">Maintain Appropriate Speed</div>
							<div class="txt">Observe Discipline & Punctuality</div>
						</div>
						<div class="main_box_el line_spec">
							<div class="tit">The Four Rules for Joy</div>
							<div class="diver"></div>
							<div class="txt">Be Respectful to Superiors</div>
							<div class="txt" style="padding-top: 0px;">Be Kind to Juniors</div>
							<div class="txt" style="padding-top: 0px;">Be Harmonious with People</div>
							<div class="txt" style="padding-top: 0px;">Be True in Handing Affairs</div>
						</div>
					</div>
				</div>
				<!--区域1-->
			</div>
			<!--块3-->
			<!--块4-->
			<div class="main_box_4">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_5.webp" />
					</div>
					<div class="tit">Business Policy</div>
					<div class="txt">
						<span><img src="../../../assets/img_public/about/qywh/icon_1.png" /></span>Perfect Quality
					</div>
					<div class="txt">
						<span><img src="../../../assets/img_public/about/qywh/icon_2.png" /></span>Sincere Service
					</div>
					<div class="txt">
						<span><img src="../../../assets/img_public/about/qywh/icon_3.png" /></span>Standardized Management
					</div>
					<div class="txt">
						<span><img src="../../../assets/img_public/about/qywh/icon_4.png" /></span>Pioneering & Innovation
					</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2">
					<div class="main_box" data-aos="zoom-in-up" data-aos-duration="400" data-aos-once="true">
						<div class="main_box_el">
							<div class="tit">CU Belief</div>
							<div class="diver"></div>
							<div class="txt">Gifts Create Values</div>
						</div>
						<div class="main_box_el">
							<div class="tit">CU Purpose</div>
							<div class="diver"></div>
							<div class="txt">Safety Effectiveness Commitment</div>
						</div>
						<div class="main_box_el">
							<div class="tit">CU Slogan</div>
							<div class="diver"></div>
							<div class="txt">Aspire to Soar High, yet Stay Grounded in Action.</div>
						</div>
					</div>
				</div>
				<!--区域2-->
				<!--区域3-->
				<div class="block_3" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_6.png" />
					</div>
					<div class="txt_box">
						<div class="tit">CU Vision</div>
						<div class="txt">From Organic to Restful, Full Supply Chain Services @ 2.1 Billion People</div>
					</div>
					<div class="txt_box">
						<div class="tit">CU Talent</div>
						<div class="txt">We are Family, Embrace & Replace</div>
						<div class="txt">Welcome A-players, Let Go of B-behaviors</div>
					</div>
				</div>
				<!--区域3-->
			</div>
			<!--块4-->
			<!--块5-->
			<div class="main_box_5">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="tit">CU Normalization</div>
					<div class="txt">Normalize the True Mentorship</div>
					<div class="txt">Normalize the Reward System</div>
					<div class="txt">Normalize Monitoring Delict</div>
					<!-- <div class="tips_box">
						<div class="tips_el">蟑蝇之类：</div>
						<div class="tips_el">“ 蟑 ” 泛指 存在盗用物资、吃里扒外、讹诈钱财等行为</div>
						<div class="tips_el">“ 蝇 ” 泛指 具有消极怠工、散布反派言论等负能量</div>
					</div> -->
				</div>
				<!--区域1-->
			</div>
			<!--块5-->
			<!--块6-->
			<div class="main_box_6">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_7.png" />
					</div>
					<div class="txt_box">
						<div class="tit">CU "The Two Don't "</div>
						<div class="tit_spec">&ensp;&ensp;Mess Around</div>
						<div class="txt">&ensp;1.1&nbsp;Have standards, but not following the standards,</div>
						<div class="txt">&ensp;1.2&nbsp;Work blindly when there is no standard,</div>
						<div class="txt">&ensp;1.3&nbsp;Do without questioning when you know there is something wrong with thestandard;</div>
						<div class="tit_spec">&ensp;&ensp;Talk Nonsense</div>
						<div class="txt">&ensp;2.1&nbsp;Jump to conclusions without investigation or research,</div>
						<div class="txt">&ensp;2.2&nbsp;Overconfidence it will work without trying it,</div>
						<div class="txt">&ensp;2.3&nbsp;Believe it will always be the case with one single proof.</div>
					</div>
				</div>
				<!--区域1-->
				<!--区域2-->
				<div class="block_2" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="tit">Current Mission</div>
					<div class="txt">Provide Affordable, Use-friendly & Precision Diagnostic Products for theWorld</div>
					<div class="txt">Change Global Diagnostics Together</div>
				</div>
				<!--区域2-->
				<!--区域3-->
				<div class="block_3" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<!-- <div class="img_box">
						<img src="../../../assets/img_public/about/qywh/block_bg_8.png" @click="bfVideo" />
					</div> -->
					<div class="txt_box">
						<!-- <span class="icon">.</span> -->
						<span class="tit">Life</span>
						<span class="txt">It's hard to balance loyalty & filial piety, choose the golden mean.</span>
					</div>
					<div class="txt_box">
						<!-- <span class="icon">.</span> -->
						<span class="tit">Human Nature</span>
						<span class="txt">People tend to care about themselves first.</span>
					</div>
				</div>
				<!--区域3-->
			</div>
			<!--块6-->
			<!--块7-->
			<div class="main_box_7">
				<!--区域1-->
				<div class="block_1" data-aos="fade-up" data-aos-duration="400" data-aos-once="true">
					<div class="tit">This World</div>
					<div class="txt">Everything is in Flux, Keeping Pace with the Times.</div>
					<div class="img_box">
						<!-- <img src="../../../assets/img_public/about/qywh/icon_earth.png" /> -->
						<!-- <video ref="videoDom" muted autoplay loop
					      :controls="false"
						  x5-video-player-type="h5"
						  webkit-playsinline="true"
						  x-webkit-airplay="true"
						  playsinline="true"
						  x5-video-player-fullscreen="true"
						  muted>
							<source src="https://culture.baoyitong.com.cn/world.mp4" type="video/mp4">
						</video> -->
						<video
							webkit-playsinline="true"
							x-webkit-airplay="true" 
							playsinline="true" 
							x5-video-player-type="h5"
							x5-video-player-fullscreen="true" 
							width="100%" 
							height="100%"
							ref="example_video" 
							class="video-js" 
							preload='auto'
							autoplay='true'
							loop
							muted
						>
							<source src="https://culture.baoyitong.com.cn/world_en.mp4" type="video/mp4">
						</video>
					</div><!--https://culture.baoyitong.com.cn/world.mp4-->
				</div>
				<!--区域1-->
			</div>
			<!--块7-->
		</div>
		<!--内容-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
export default {
	components:{
		navbar,
		footerBox,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			linkData: [
				{data: [
					{imgUrl: require('@/assets/img_public/about/qywh/link_7.png'), href: 'https://cordx.com/', class: 'link_img_7'},
					{imgUrl: require('@/assets/img_public/about/qywh/bonore.png'), href: 'https://m.bonore.com', class: 'link_img_3'},
					{imgUrl: require('@/assets/img_public/about/qywh/abiores.webp'), href: 'https://abiores.com/', class: 'link_img_2'},
				]},
				{data: [
					{imgUrl: require('@/assets/img_public/about/qywh/ucreagent.png'), href: 'https://ucreagent.com', class: 'link_img_4'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_6.png'), href: 'https://i-membrane.com/', class: 'link_img_6'},
					{imgUrl: require('@/assets/img_public/about/qywh/link_4.png'), href: 'https://cupet.com', class: 'link_img_5'},
				],}
			],
		}
	},
	created(){
		let that = this;
		if(!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
			that.$router.replace({path: '/culture'});
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		bfVideo() {
			let that = this;
			//that.$refs.example_video.pause();
		},
	},
}
</script>

<style lang="less" scoped>
	
/*开屏*/
.start_box{
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	.btn_box{
		width: 100%;
		display: flex;
		align-items: center;
		padding: 40px 30px 0 30px;
	}
	.img_box{
		img{
			width: 100%;
		}
	}
	.tit_box{
		display: flex;
		align-items: center;
		padding-top: 20px;
		writing-mode: vertical-lr;
		width: 100%;
		line-height: unset;
		letter-spacing: 4px;
		font-size: 16px;
		color: #000000;
	}
}

/*轮播图*/
.banner_box{
	background-color: #541554;
	display: flex;
	position: relative;
	top: -1px;
	align-items: center;
	padding-top: 20px;
	.left{
		flex: 1;
		padding-left: 16px;
		.tit{
			font-size: 24px;
			font-weight: bold;
			color: #ffffff;
		}
		.txt{
			color: #ffffff;
			font-size: 12px;
		}
	}
	.right{
		width: auto;
		img{
			width: 165px;
		}
	}
}

/*块7*/
.main_box_7{
	.block_1{  /*区域1*/
		position: relative;
		padding-top: 50px;
		text-align: center;
		height: 360px;
		position: relative;
		overflow: hidden;
		.tit{
			padding-bottom: 10px;
			font-size: 28px;
			color: #071A21;
			font-weight: bold;
		}
		.txt{
			font-size: 16px;
			color: #333333;
		}
		.img_box{
			width: 100%;
			padding-top: 30px;
			position: absolute;
			top: 120px;
			video{
				width: 100%;
				background-color: transparent;
			}
			img{
				width: 100%;
				animation: rotation 360s linear 0s infinite;
			}
		}
		.bg{
			position: absolute;
			z-index: 1;
			bottom: -1px;
			img{
				width: 100%;
			}
		}
	}
}
@-webkit-keyframes rotation {
	0%{-webkit-transform:rotate(0deg);}
	50%{-webkit-transform:rotate(180deg);}
	100%{-webkit-transform:rotate(360deg);}
}
/*块6*/
.main_box_6{
	.block_3{  /*区域3*/
		padding: 60px 16px 0 0;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.txt_box{
			padding-left: 16px;
			padding-bottom: 20px;
			text-align: center;
			.icon{
				position: relative;
				top: -6px;
				padding-right: 10px;
				font-size: 36px;
				font-weight: bold;
				color: #333333;
			}
			.tit{
				padding-right: 15px;
				margin-right: 12px;
				display: inline-block;
				line-height: 0.6;
				font-size: 18px;
				font-weight: bold;
				color: #071A21;
				border-right: 2px solid #071A21;
				padding-top: 4px;
			}
			.txt{
				position: relative;
				// top: -4px;
				font-size: 18px;
				color: #071A21;
				font-weight: bold;
			}
		}
	}
	.block_2{  /*区域2*/
		padding: 60px 16px 0 16px;
		.tit{
			padding: 0 0px 15px 0;
			margin-bottom: 10px;
			font-size: 28px;
			font-weight: bold;
			color: #071A21;
			line-height: 1;
			text-align: center;
		}
		.txt{
			font-size: 16px;
			line-height: 24px;
			color: #333333;
			text-align: center;
		}
	}
	.block_1{  /*区域1*/
		padding: 60px 0 0 16px;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.txt_box{
			padding: 0 16px 0 0;
			.tit{font-size: 28px;font-weight: bold;color: #071A21;}
			.tit_spec{font-size: 16px;font-weight: bold;color: #071A21;padding: 10px 0 8px 0;}
			.txt{font-size: 16px;color: #333333;line-height: 24px;text-indent: 24px;}
		}
	}
}
/*块5*/
.main_box_5{
	padding: 60px 0;
	background-color: #F4EDE4;
	.block_1{  /*区域1*/
		text-align: center;
		.tit{
			padding-bottom: 15px;
			color: #071A21;
			font-size: 28px;
			font-weight: bold;
		}
		.txt{
			font-size: 16px;
			color: #333333;
			line-height: 24px;
		}
		.tips_box{
			padding-top: 30px;
			.tips_el{
				color: #999999;
				font-size: 12px;
				line-height: 18px;
			}
		}
	}
}
/*块4*/
.main_box_4{
	padding-bottom: 30px;
	.block_3{  /*区域3*/
		padding: 40px 16px 0 0;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.txt_box{
			padding-bottom: 20px;
			.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
			.txt{
				font-size: 16px;
				color: #333333;
				line-height: 24px;
			}
		}
	}
	.block_2{  /*区域2*/
		padding: 45px 16px 0px 16px;
		.main_box{
			.main_box_el{
				padding: 40px 0;
				margin-bottom: 20px;
				// border: 1px solid #541554;
				border-radius: 12px;
				text-align: center;
				background-color: #F7F6F9;
				.diver{
					width: 30px;
					height: 4px;
					background-color: #A50073;
					border-radius: 4px;
					margin: 8px auto 12px auto;
				}
				.tit{
					padding-bottom: 5px;
					font-size: 24px;
					color: #000000;
				}
				.txt{
					font-size: 16px;
					color: #071A21;
				}
			}
		}
	}
	.block_1{  /*区域1*/
		padding: 60px 0 0 16px;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{
			font-size: 16px;
			color: #333333;
			line-height: 32px;
			padding: 4px 0;
			span{
				display: inline-block;
				width: 26px;
				height: 26px;
				line-height: 30px;
				display: inline-block;
				background-color: #F7F6F9;
				text-align: center;
				margin-right: 6px;
				border-radius: 50%;
				img{
					width: 15px;
					position: relative;
					top: 5px;
				}
			}
		}
	}
}
/*块3*/
.main_box_3{
	padding: 50px 0 0 0;
	background-color: #F5EDE5;
	.block_1{
		.main_box{
			display: flex;
			justify-content: center;
			.main_box_el{
				flex: 1;
				color: #000000;
				text-align: center;
				padding-bottom: 40px;
				.diver{
					width: 15px;
					height: 2px;
					border-radius: 4px;
					background-color: #A50073;
					margin: 0 auto;
					margin-bottom: 20px;
				}
				.tit{
					display: inline-block;
					padding-bottom: 10px;
					font-size: 28px;
					// border-bottom: 1px solid #ffffff;
				}
				.txt{
					font-size: 16px;
					line-height: 24px;
					color: #000000;
				}
			}
		}
	}
}
/*块2*/
.main_box_2{
	padding-bottom: 50px;
	.block_3{  /*区域3*/
		padding: 60px 16px 0 0;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;}
	}
	.block_2{  /*区域2*/
		padding: 60px 0 0 16px;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.tit_spec{font-size: 16px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;line-height: 24px;}
	}
	.block_1{  /*区域1*/
		padding-top: 0px;
		img{
			width: 100%;
		}
	}
}
/*块1*/
.main_box_1{
	padding-bottom: 50px;
	background-color: #FBF6EF;
	.block_2{  /*区域2*/
		padding: 60px 16px 0 0;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;line-height: 24px;}
	}
	.block_1{  /*区域1*/
		padding: 60px 0 0 16px;
		text-align: center;
		.img_box{
			padding-bottom: 30px;
			img{width: 100%;}
		}
		.tit{font-size: 28px;font-weight: bold;color: #071A21;padding-bottom: 10px;}
		.txt{font-size: 16px;color: #333333;}
	}
	.link_box{  /*关联网站*/
		padding: 15px 16px 0 16px;
		.tit{
			color: #071A21;
			font-size: 20px;
			text-align: center;
		}
		.link_main{
			display: flex;
			padding: 15px 0;
			align-items: center;
			div{
				flex: 1;
				text-align: center;
			}
			.link_img_1{
				position: relative;
				img{width: 78px;}
			}
			.link_img_2{
				img{width: 100px;}
			}
			.link_img_3{
				position: relative;
				img{width: 85px;}
			}
			.link_img_4{
				position: relative;
				left: 0%;
				img{height: 25px;}
			}
			.link_img_5{
				position: relative;
				left: 0;
				img{width: 80px;}
			}
			.link_img_6{
				position: relative;
				img{height: 25px;}
			}
			.link_img_7{
				img{width: 80px;}
			}
		}
	}
}


@media only screen and (min-device-width : 768px) and (max-device-width : 850px){
	.main_box_7{
		.block_1{  /*区域1*/
			height: 600px;
		}
	}
}

@media only screen and (min-device-width : 851px) and (max-device-width : 1024px){
	.main_box_7{
		.block_1{  /*区域1*/
			height: 750px;
		}
	}
}
</style>
